/**
 * Compact string for diff-table before/after cells. Objects JSON-stringify;
 * long strings clip to `maxLen`. `absent` is the label for `undefined`
 * (ingest gwbk diffs use `<absent>`; session changeset uses `∅`).
 */
export function previewDiffValue(
  v: unknown,
  opts: { maxLen?: number; absent?: string } = {}
): string {
  const maxLen = opts.maxLen ?? 120
  const absent = opts.absent ?? '<absent>'
  if (v === undefined) return absent
  if (v === null) return 'null'
  if (typeof v === 'string') {
    return v.length > maxLen ? `${v.slice(0, maxLen - 1)}…` : v
  }
  if (typeof v === 'number' || typeof v === 'boolean') return String(v)
  try {
    const s = JSON.stringify(v)
    return s.length > maxLen ? `${s.slice(0, maxLen - 1)}…` : s
  } catch {
    return String(v)
  }
}
